<div class="king-row__wrapper box-black-third hover">
  <div class="king-row--game grid-item-1">
    <span
      (click)="
        clipboardService.copy(game().gameid, 'King GameId Copy Success!')
      "
      class="king-row--game__gameid"
    >Game ID #{{ game().gameid }}</span
    >
    <span class="king-row--game__roundid">Round {{ game().roundid }}</span>
  </div>
  <div
    class="king-row__player king grid-item-0"
    [class.opacity-20]="
      game().king.steamid !== game().winner.steamid && game().part
    "
  >
    <app-king-user-avatar
      [isChallenger]="false"
      [kingUser]="game().king"
      [size]="2"
      [isWinner]="game().king.steamid === game().winner.steamid"
      [disableAnimation]="true"
    ></app-king-user-avatar>
    <div class="king-row--value king">
      <app-cost
        [gap]="4"
        [cost]="game().king.value"
        [balanceType]="'skins'"
        color="var(--red)"
      />
    </div>
  </div>
  <app-skins-row
    class="king-row__skins grid-item-2"
    [skins]="skins()"
    skinSize="medium"
    (handleClick)="onClick()"
    [maxItemLength]="6"
  >
  </app-skins-row>

  <div
    class="king-row__player challenger grid-item-4"
    [class.opacity-20]="
      game().part?.steamid !== game().winner.steamid && game().part
    "
  >
    @if (game().part) {
      <app-king-user-avatar
        [size]="2"
        [isChallenger]="true"
        [kingUser]="game().part || null"
        [isWinner]="game().part?.steamid === game().winner.steamid"
        [disableAnimation]="true"
      ></app-king-user-avatar>
      <div class="king-row--value challenger">
        <app-cost
          [gap]="4"
          [cost]="game().part!.value"
          [balanceType]="'skins'"
          color="var(--blue)"
        />
      </div>
    } @else {
        <svg-icon
                class="king-row--ran-away flex items-center justify-center"
                src="assets/icons/king-new/run-away.svg"
        >
        </svg-icon>
    }
  </div>
  <div class="king-row__fairness grid-item-3">
    <app-fairness-button
      href="/provably-fair/king/{{ game().gameid }}"
    ></app-fairness-button>
  </div>
</div>
